import { RiCircleFill, RiFileLine, RiFolderLine } from '@remixicon/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

interface TableWidgetsLayoutProps {
    className?: string;
    folderCount?: number;
    fileCount?: number;
    activeCount?: number;
    inactiveCount?: number;
}

const TableWidgetsLayout: FC<TableWidgetsLayoutProps> = ({
    className,
    folderCount = 0,
    fileCount = 0,
    activeCount = 0,
    inactiveCount = 0,
}) => {
    const { t } = useTranslation();
    return (
        <div
            className={twMerge(
                'flex h-9 justify-start items-center px-4 py-2 bg-[#edf0f2] dark:bg-[#202222] rounded w-full',
                className,
            )}
            data-testid="table-widgets"
        >
            <div className="flex gap-2 mr-8 h-5 justify-start items-center">
                <RiFolderLine className="h-4 leading-5 text-[#D4C1FB]" />
                <p className="font-roboto font-semibold text-sm whitespace-nowrap">{`${folderCount} ${t(
                    'knowledgeManager.table.folders',
                )}`}</p>
            </div>
            <div className="flex gap-2 mr-4 h-5 justify-start items-center">
                <RiFileLine className="h-4 leading-5 text-[#D4C1FB]" />
                <p className="font-roboto font-semibold text-sm whitespace-nowrap">{`${fileCount} ${t(
                    'knowledgeManager.table.files',
                )}`}</p>
            </div>
            <div className="flex gap-2 mr-4 h-5 justify-start items-center">
                <RiCircleFill className="h-2 leading-5 text-[#5317EE]" />
                <p className="font-roboto font-semibold text-sm whitespace-nowrap">{`${activeCount} ${t(
                    'knowledgeManager.table.actives',
                )}`}</p>
            </div>
            <div className="flex gap-2 mr-4 h-5 justify-start items-center">
                <RiCircleFill className="h-2 leading-5 text-[#546E7A]" />
                <p className="font-roboto font-semibold text-sm whitespace-nowrap">{`${inactiveCount} ${t(
                    'knowledgeManager.table.notActives',
                )}`}</p>
            </div>
        </div>
    );
};
export default TableWidgetsLayout;
